import * as React from 'react';

/**
 * Shown in place of a page the signed in user is not permitted to open.
 * Follows the session timeout screen in layouts/Admin.jsx.
 */
export default class AccessDenied extends React.Component {
    render() {
        const message = this.props.message ||
            "This page is restricted. If you think you should have access, contact a Management Portal administrator.";

        return (
            <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
                <h2>You don't have access to this page.</h2>
                <p>{message}</p>
                <button
                    className="btn btn-primary btn-fill btn-wd"
                    onClick={() => this.props.history.push("/portal/home")}
                >
                    Back to Home
                </button>
            </div>
        );
    }
}
